// extracted by mini-css-extract-plugin
export default {"app_body":"class_app_body__JUB4+","col-xs-0":"class_col-xs-0__+PWJv","col-sm-0":"class_col-sm-0__xGTcb","col-md-0":"class_col-md-0__NKFor","col-lg-0":"class_col-lg-0__X1tCE"};